'use client';

import { c as _c } from "react/compiler-runtime";
import { type Factiii } from '@shared/all/domains/factiiis';
import { type TagValue } from '@shared/utils/helpers/tagValues';
import Link from 'next/link';
import Avatar from '../common/Avatar';

// The values this post's factiiis carry (a number, text, a date), one row per
// tag with the factiii it belongs to. Same row UX as the other panels.
export default function TagValuesPanel(t0) {
  const $ = _c(7);
  const {
    values,
    factiiisById
  } = t0;
  let t1;
  if ($[0] !== factiiisById || $[1] !== values) {
    let t2;
    if ($[3] !== factiiisById) {
      t2 = (v, i) => {
        const factiii = factiiisById.get(v.factiiiId);
        return <li key={`${v.factiiiId}-${i}`}><Link href={`/f/${factiii?.slug ?? ""}`} onClick={_temp} className="flex min-w-0 items-center gap-2 rounded px-2 py-1 text-sm text-textPrimary hover:bg-primary/10"><Avatar factiiiId={v.factiiiId} factiiiAvatarKey={factiii?.avatarKey ?? null} size={24} /><span className="min-w-0 flex-1"><span className="block truncate text-xs text-textSecondary">{factiii?.name ?? ""}</span><span className="block break-words font-semibold">{v.label}</span></span></Link></li>;
      };
      $[3] = factiiisById;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = values.map(t2);
    $[0] = factiiisById;
    $[1] = values;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex flex-col gap-1">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(e) {
  return e.stopPropagation();
}